module.exports = {
  'en': {
    'HRMS12X': {
      '10': 'Subject',
      '20': 'Message',
      '30': 'Search condition',
      '40': 'List of employee for sending mail',
      '50': 'Seq.',
      '60': 'Emp. Code',
      '70': 'Name',
      '80': 'Department',
      '90': 'Position',
      '100': 'Attach file',
      '110': 'Sender Code',
      '120': 'From Dept.',
      '130': 'E-Mail Detail',
      '140': 'Detail for record cannot send e-mail',
      '150': 'E-Mail'
    }
  },
  'th': {
    'HRMS12X': {
      '10': 'เรื่อง',
      '20': 'ข้อความ',
      '30': 'Criteria ในการเลือกพนักงาน',
      '40': 'รายชื่อพนักงานที่ต้องการส่ง',
      '50': 'ลำดับที่',
      '60': 'รหัสพนักงาน',
      '70': 'ชื่อ',
      '80': 'หน่วยงาน',
      '90': 'ตำแหน่ง',
      '100': 'Attach file',
      '110': 'รหัสผู้ส่ง mail',
      '120': 'จากหน่วยงาน',
      '130': 'รายละเอียด E-Mail',
      '140': 'รายการที่ไม่สามารถส่ง E-Mail',
      '150': 'E-Mail'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hrms12x.js